function formatPrice(price) {
    const formatedPrice = price / 100;
    return 'R$ ' + formatedPrice.toFixed(2);
}

document.addEventListener('DOMContentLoaded', function() {
  initRelatedProducts();
});

function initRelatedProducts() {
  const container = document.getElementById('related-products-container');
  if (container) {
    const productId = container.getAttribute('data-product-id');
    if (productId) {
        loadRelatedProducts(productId);
    }
  }
}

function loadRelatedProducts(productId) {
  const containerContent = document.querySelector('.related-products__content');
  if (!containerContent) return;
  fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}&intent=related`)
      .then(response => response.json())   
      .then(data => {
          let productHTML = '';
          data.products.forEach(product => {
              productHTML += buildProductHTML(product);
          });
          containerContent.innerHTML = productHTML;
          setupFunctionsProductsBlock();
          buildSwiper();
      })
      .catch(handleError);
}


function setupFunctionsProductsBlock() {
  const selectVariants = document.querySelectorAll('.related-product-variants');
  selectVariants.forEach(selectVariant => {
    const cardContainer = selectVariant.closest('.card__container');
    if (!cardContainer) return;

    const addToCartButton = cardContainer.querySelector('.add-to-cart');
    if (!addToCartButton) return;

    addToCartButton.addEventListener('click', () => {
      adicionarAoCarrinho(addToCartButton.getAttribute('data-product-id'));
    });

    selectVariant.addEventListener('change', function (event) {
        const variantId = event.target.value;
        addToCartButton.setAttribute('data-product-id', variantId);
    });
  })
}


function buildProductHTML(product) {
  if (!product.available || product.tags.includes('brinde')) return '';

  let productOptions = '<select ' 
  if(product.variants.length == 1 && product.variants[0].title == 'Default Title'){
    productOptions += 'style="display: none" ';
  }

  productOptions += 'class="related-product-variants">';
  product.variants.forEach(variant => {
      if (variant.available) {
        productOptions += `<option value="${variant.id}" product-variant-id="${variant.id}" >${variant.title}</option>`;           
      }
    });

  productOptions += '</select>';

  return `
      <div class="related-product swiper-slide">
          <div class="card__container">
              <div class="main-card__container">
                  <img class="related-product__img" src="${product.featured_image}" alt="${product.title}">
                  <div class="main-card__info">
                      <p class="related-product-title">${product.title}</p>
                      ${productOptions}
                      <p class="related-product-price">${formatPrice(product.price)}</p>
                      <p class="btn__see-product add-to-cart" data-product-id="${ product.variants.filter(variant => variant.available)[0].id }"  >Adicionar</p>
                  </div>
              </div>
          </div>
      </div>
  `;
}

function buildSwiper() {
  const swiperContainer = document.querySelector('#related-products-container');
  if (swiperContainer && typeof Swiper !== 'undefined') {
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1.3,
      spaceBetween: 10,
      navigation: {
        nextEl: '.related-swiper-button-next',
        prevEl: '.related-swiper-button-prev',
      },
      breakpoints: {
        425: {
          slidesPerView: 2.2,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 10
        }
      }
    });
  }
}


function handleError(error) {
  console.error('Error loading related products:', error);
}

function updateCart() {
  const cartItemsEl = document.querySelector('cart-items');

  if (cartItemsEl && typeof cartItemsEl.onCartUpdate === 'function') {
    if (window.handleMilestoneGifts) {
      window.handleMilestoneGifts(cartItemsEl.onCartUpdate.bind(cartItemsEl));
    } else {
      cartItemsEl.onCartUpdate();
    }
  } 
  else {
    if (window.handleMilestoneGifts) {
      window.handleMilestoneGifts(() => { 
        location.reload(); 
      });
    } else {
      location.reload();
    }
  }
}

function adicionarAoCarrinho(produtoId) {
  const cartItemsEl = document.querySelector('cart-items');
  if (cartItemsEl && typeof cartItemsEl.enableLoading === 'function') {
    cartItemsEl.enableLoading();
  }

  const dados = {
    items: [{
      id: produtoId,
      quantity: 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(dados)
  })
  .then(response => {
    if (response.ok) {
      return response.json();
    }
    if (cartItemsEl && typeof cartItemsEl.disableLoading === 'function') {
      cartItemsEl.disableLoading();
    }
    throw new Error('Error adding product to cart.');
  })
  .then(cart => {
    updateCart();
  })
  .catch(error => {
    console.error('Error:', error);
    if (cartItemsEl && typeof cartItemsEl.disableLoading === 'function') {
      cartItemsEl.disableLoading();
    }
  });
}